import { toast } from "react-toastify";
import { API_END_POINTS } from "../../../utils/config";
import JsonInterceptor from "../../../utils/JsonInterceptor";
import { CustomerType } from "./type";
import { errorMessage } from "../../../utils/custom";

export const getCustomers = (body) => async (dispatch) => {
  try {
    dispatch({ type: CustomerType.GET_CUSTOMERS_REQUEST });
    let apiEndpoint = `${API_END_POINTS.getCustomers}`;
    const { data } = await JsonInterceptor.post(`${apiEndpoint}`, body);
    return dispatch({
      type: CustomerType.GET_CUSTOMERS_SUCCESS,
      payload: data
    });
  } catch (error) {
    const message = error && error.data?.message ? error.data?.message : errorMessage();
    toast.error(message);
    return dispatch({ type: CustomerType.GET_CUSTOMERS_FAIL, error: message });
  }
};
export const getListedCustomersBonus = (body) => async (dispatch) => {
  try {
    dispatch({ type: CustomerType.GET_LISTED_CUSTOMERS_BONUS_REQUEST });
    let apiEndpoint = `${API_END_POINTS.getCustomerListBonusListApi}`;
    const { data } = await JsonInterceptor.post(`${apiEndpoint}`, body);
    return dispatch({
      type: CustomerType.GET_LISTED_CUSTOMERS_BONUS_SUCCESS,
      payload: data
    });
  } catch (error) {
    console.log(error);
    const message = error && error.data?.message ? error.data?.message : errorMessage();
    toast.error(message);
    return dispatch({ type: CustomerType.GET_LISTED_CUSTOMERS_BONUS_FAIL, error: message });
  }
};
export const getCustomersBalance = (body) => async (dispatch) => {
  try {
    dispatch({ type: CustomerType.GET_CUSTOMER_BALANCE_REQUEST });
    let apiEndpoint = `${API_END_POINTS.getCustomersBalance}`;
    const { data } = await JsonInterceptor.post(`${apiEndpoint}`, body);
    return dispatch({
      type: CustomerType.GET_CUSTOMER_BALANCE_SUCCESS,
      payload: data
    });
  } catch (error) {
    const message = error && error.data?.message ? error.data?.message : errorMessage();
    toast.error(message);
    return dispatch({ type: CustomerType.GET_CUSTOMER_BALANCE_FAIL, error: message });
  }
};

export const updateCustomerStatus = (body) => async (dispatch) => {
  try {
    dispatch({ type: CustomerType.UPDATE_STATUS_REQUEST });
    let apiEndpoint = `${API_END_POINTS.updateCustomerStatus}`;
    const { data } = await JsonInterceptor.post(`${apiEndpoint}`, body);
    return dispatch({
      type: CustomerType.UPDATE_STATUS_SUCCESS,
      payload: data
    });
  } catch (error) {
    const message = error && error.data?.message ? error.data?.message : errorMessage();
    toast.error(message);
    return dispatch({ type: CustomerType.UPDATE_STATUS_FAIL, error: message });
  }
};

export const customerDropdown = (body) => async (dispatch) => {
  try {
    dispatch({ type: CustomerType.GET_CUSTOMER_DROPDOWN_REQUEST });
    let apiEndpoint = `${API_END_POINTS.customerDropdown}`;
    const { data } = await JsonInterceptor.post(`${apiEndpoint}`, body);
    return dispatch({
      type: CustomerType.GET_CUSTOMER_DROPDOWN_SUCCESS,
      payload: data
    });
  } catch (error) {
    const message = error && error.data?.message ? error.data?.message : errorMessage();
    toast.error(message);
    return dispatch({ type: CustomerType.GET_CUSTOMER_DROPDOWN_FAIL, error: message });
  }
};

export const changeTab = (body) => (dispatch) => {
  return dispatch({
    type: CustomerType.CHANGE_CUSTOMER_TAB,
    payload: body
  });
};
